<app-reference-short-list *ngIf="recentCommunityCurationPubs"
                          [references]="recentCommunityCurationPubs"></app-reference-short-list>
